export const CONSENT_VERSION = 1;

const STORAGE_KEY = 'haukel-consent';
const CONSENT_LIFETIME_MONTHS = 12;

export interface ConsentDecision {
    version: number;
    decidedAt: string;
    analytics: boolean;
}

function isDecision(value: unknown): value is ConsentDecision {
    if (typeof value !== 'object' || value === null) return false;
    const candidate = value as Record<string, unknown>;
    return typeof candidate.version === 'number' && typeof candidate.decidedAt === 'string' && typeof candidate.analytics === 'boolean';
}

function isExpired(decision: ConsentDecision): boolean {
    const expiry = new Date(decision.decidedAt);
    expiry.setMonth(expiry.getMonth() + CONSENT_LIFETIME_MONTHS);
    return Number.isNaN(expiry.getTime()) || expiry.getTime() < Date.now();
}

export function readConsent(): ConsentDecision | null {
    try {
        const raw = window.localStorage.getItem(STORAGE_KEY);
        if (!raw) return null;
        const parsed: unknown = JSON.parse(raw);
        if (!isDecision(parsed) || parsed.version !== CONSENT_VERSION || isExpired(parsed)) return null;
        return parsed;
    } catch {
        return null;
    }
}

export function writeConsent(analytics: boolean): ConsentDecision {
    const decision: ConsentDecision = { version: CONSENT_VERSION, decidedAt: new Date().toISOString(), analytics };
    try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(decision));
    } catch {
        return decision;
    }
    return decision;
}

export function globalPrivacyControlActive(): boolean {
    const signal = (window.navigator as Navigator & { globalPrivacyControl?: boolean }).globalPrivacyControl;
    return signal === true;
}
